// extracted by mini-css-extract-plugin
module.exports = {"container":"container-1CEwA","suggestions":"suggestions-1glJB","text":"text-y0uHw"};